"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitArrayMidway = void 0;
exports.convertDateFormat = convertDateFormat;
exports.dayjsParse = dayjsParse;
const dayjs_1 = __importDefault(require("dayjs"));
const splitArrayMidway = (array) => {
    const midIndex = Math.ceil(array.length / 2);
    return [array.slice(0, midIndex), array.slice(midIndex)];
};
exports.splitArrayMidway = splitArrayMidway;
function convertDateFormat(dateString, targetFormat) {
    const parsedDate = (0, dayjs_1.default)(dateString);
    if (!parsedDate.isValid()) {
        throw new Error(`Unable to parse date string "${dateString}"`);
    }
    return parsedDate.format(targetFormat);
}
function dayjsParse(dateString) {
    const parsedDate = (0, dayjs_1.default)(dateString, ["MM/DD/YYYY", "YYYY-MM-DD"]);
    if (!parsedDate.isValid()) {
        throw new Error(`Unable to parse date string "${dateString}"`);
    }
    return parsedDate;
}
